import React, {useEffect, useRef} from 'react';
import { StyledScrollingVideos } from './StyledScrollingVideos';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ScrollingVideos = ({ }) => {
  const scrollRef = useRef(null)
  let vh = window.innerHeight * 0.01;

  const resize =  () => {
    vh = window.innerHeight * 0.01;
  }
  useEffect(() => {
    gsap.to('.first--slide', {
      scrollTrigger: {
        trigger: '.first--slide',
        pin: true,
        endTrigger: '.last--slide',
        start: 'top top',
        end: 'top top',
        scrub: false,
        pinSpacing: false
      }
    })
  
    const videos = scrollRef.current.querySelectorAll('.video-wrap--mask');
    
    for(var i = 0; i < videos.length; i++){
      let videoEl = videos[i].querySelector('video')
      
      videoEl.muted="muted"
      videoEl.defaultMuted = true;
      gsap.to(videos[i], {
        width: '100%',
        height: '100%',
        scrollTrigger: {
          trigger: videos[i].parentNode,
          start: 'top bottom',
          scrub: 1,
          end: 'top top'
          
        }
      })
    }
      
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.addEventListener('resize', () =>resize())
    document.querySelector('body').addEventListener('scroll', () =>resize())
    return () => {
      document.removeEventListener('resize', () => resize())
      document.querySelector('body').removeEventListener('scroll', () =>resize())
    }
    
  }, []);

  
  return (
    <React.Fragment>
      {
          <StyledScrollingVideos>
            <div className="first--slide ">
              <h5 className="big--title">Open the door to</h5>
            </div>
            <div className="videos-scroller" ref={scrollRef}>
              <div className="video--slide">
                <h5 className="big--title">advanced technologies that feel real</h5>
                <div className="video-wrap">
                  <div className="video-wrap--mask video-wrap--mask-1">
                    <div className="over-video"></div>
                    <video autoPlay loop playsInline muted preload="metadata" >
                      <source src={require('../../assets/scroll-home-video/home-1-comp.mp4')}></source>
                    </video>
                  </div>
                </div>
              </div>
              <div className="video--slide">
                <h5 className="big--title">limitless levels of engagement</h5>
                <div className="video-wrap">
                  <div className="video-wrap--mask video-wrap--mask-2">
                    <div className="over-video"></div>
                    <video autoPlay loop playsInline muted preload="metadata" >
                      <source src={require('../../assets/scroll-home-video/home-2-comp.mp4')}></source>
                    </video>
                  </div>
                </div>
              </div>
              <div className="video--slide last--slide">
                <h5 className="big--title">new experiences in the world of retail. </h5>
                <div className="video-wrap">
                  <div className="video-wrap--mask video-wrap--mask-3">
                    <div className="over-video"></div>
                    <video autoPlay loop playsInline muted preload="metadata" >
                      <source src={require('../../assets/scroll-home-video/home-3.mp4')}></source>
                    </video>
                  </div>
                </div>
              </div>
            </div>
            
            
          </StyledScrollingVideos>
          
      }
    </React.Fragment>
  );
};



export default ScrollingVideos;
